import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';

const UnselectedOppositeESThroughFareWarning = ({ isOpen, closeModal }) => (
  <Modal
    isOpen={isOpen}
    title={<FormattedMessage id="searchResults.cannotBeBooked" />}
    subtitle={<FormattedMessage id="aftersalesWarning.unselectedOppositeESThroughFare" />}
    onClose={closeModal}
  ></Modal>
);

UnselectedOppositeESThroughFareWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func
};

export default UnselectedOppositeESThroughFareWarning;
